import { useContext } from 'react';
import AppContext from '../../AppContext';
import decodeHTML from '../../utils/html';
import './Artikelinfo.scss';
import UnsafeHtml from '../common/UnsafeHtml';
import { appConfig } from '../../config';

function Artikelinfo() {
  const { appData } = useContext(AppContext);

  return (
    <div className="configurator__artikelinfo product-info-inner">
      <div className="product-headline">
        <h1 className="product-title h2" itemProp="name">{decodeHTML(appData.static.artikel.name)}</h1>
      </div>
      { !appConfig.external
        && (
        <ul className="info-essential list-unstyled">
          <li className="product-sku">
            <strong>Artikelnummer:&nbsp;</strong>
            <span itemProp="sku">{appData.static.artikel.artNr}</span>
          </li>
          <li className="product-category word-break">
            <strong>Kategorie:&nbsp;</strong>
            <a href={appData.static.kategorie.url} itemProp="category">{appData.static.kategorie.name}</a>
          </li>
        </ul>
        )}
      <div className="shortdesc" itemProp="description">
        <UnsafeHtml unsafeHtml={appData.static.artikel.kurzBeschreibung} />
      </div>
      <div>
        <span className="highlight">{appData.static.shop.deutscheSprachvariablen.productDetails.maßanfertigungHervorgehoben}</span>&nbsp;
        {appData.static.shop.deutscheSprachvariablen.productDetails.maßanfertigungText}
      </div>
    </div>
  );
}

export default Artikelinfo;
